import { render, staticRenderFns } from "./xqXq.vue?vue&type=template&id=52ed9954&scoped=true"
import script from "./xqXq.vue?vue&type=script&lang=js"
export * from "./xqXq.vue?vue&type=script&lang=js"
import style0 from "./xqXq.vue?vue&type=style&index=0&id=52ed9954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed9954",
  null
  
)

export default component.exports